/** Shared V2 chrome tokens — driven by global brand theme */

import { brand } from "brand/theme";

export const V2 = {
  ink: brand.colors.ink,
  muted: brand.colors.muted,
  line: brand.colors.line,
  accent: brand.colors.accent,
  accentHover: brand.colors.accentHover,
  accentSoft: brand.colors.accentSoft,
  accentBorder: brand.colors.accentBorder,
  onAccent: brand.colors.onAccent,
  surface: "rgba(255, 255, 255, 0.82)",
  surfaceSolid: brand.colors.surface,
  bg: brand.colors.bg,
  fontBody: brand.fonts.body,
  fontDisplay: brand.fonts.display,
  fontMono: brand.fonts.mono,
  radius: brand.radius,
};

/** Icon / action buttons in the header — transparent, no border */
export const headerIconButtonSx = (active = false) => ({
  width: 40,
  height: 40,
  minWidth: 40,
  minHeight: 40,
  p: 0.75,
  fontSize: "1.25rem",
  color: active ? V2.accent : V2.ink,
  bgcolor: "transparent !important",
  backgroundColor: "transparent !important",
  border: "none",
  borderRadius: 'var(--radius)',
  boxShadow: "none",
  transition: "background 0.2s ease, color 0.2s ease",
  "&:hover": {
    bgcolor: `${V2.accentSoft} !important`,
    backgroundColor: `${V2.accentSoft} !important`,
    color: V2.accent,
  },
  "&::after": {
    display: "none",
  },
});

export const headerAppBarSx = {
  bgcolor: V2.surfaceSolid,
  backgroundImage: "none",
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  borderBottom: `1px solid ${V2.line}`,
  boxShadow: "none",
  zIndex: 1200,
  top: 0,
  fontFamily: V2.fontBody,
};
